var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter-reading-size-online"},[_c('Echart',{ref:"option",staticStyle:{"height":"100%"},attrs:{"options":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }